/* HSF Luxury — theme.js
   Vanilla JS: drawer menu, product gallery, variant picker,
   quantity steppers, AJAX add-to-cart with toast, filter drawer. */

(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Scroll reveal ---------- */
  if (!reduceMotion && 'IntersectionObserver' in window) {
    document.documentElement.classList.add('anim-ready');

    var revealTargets = document.querySelectorAll(
      '.section-header, .product-card, .category-card, .value-prop, .testimonial, ' +
      '.gallery-item, .media-text__media, .media-text__content, .cta-banner__card, ' +
      '.site-footer__main > *, .collection-hero, .page-head, .contact-details, ' +
      '.product-accordions, .trust-row, .feature-tile, .story-strip'
    );
    revealTargets.forEach(function (el) { el.classList.add('reveal'); });

    /* Stagger siblings inside grids so rows cascade in */
    document.querySelectorAll('.grid, .product-grid, .gallery-grid, .site-footer__main').forEach(function (group) {
      Array.prototype.forEach.call(group.children, function (child, i) {
        child.style.setProperty('--rd', Math.min(i * 0.06, 0.3) + 's');
      });
    });

    var revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -7% 0px', threshold: 0.05 });

    revealTargets.forEach(function (el) { revealObserver.observe(el); });
  }

  /* ---------- Header shadow on scroll ---------- */
  var siteHeader = document.querySelector('.site-header');
  if (siteHeader) {
    var onScroll = function () {
      siteHeader.classList.toggle('is-scrolled', window.scrollY > 12);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Mobile drawer ---------- */
  document.querySelectorAll('[data-drawer-open]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      document.body.classList.add('drawer-open');
      var drawer = document.getElementById('MobileDrawer');
      if (drawer) {
        var firstLink = drawer.querySelector('a, button');
        if (firstLink) firstLink.focus();
      }
    });
  });
  document.querySelectorAll('[data-drawer-close]').forEach(function (el) {
    el.addEventListener('click', function () {
      document.body.classList.remove('drawer-open');
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') document.body.classList.remove('drawer-open');
  });

  /* ---------- Product gallery (crossfade swap) ---------- */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-gallery-main] img');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (!main || main.src === thumb.dataset.src) return;
        main.classList.add('is-fading');
        var swap = function () {
          main.src = thumb.dataset.src;
          if (thumb.dataset.alt) main.alt = thumb.dataset.alt;
          main.addEventListener('load', function () {
            main.classList.remove('is-fading');
          }, { once: true });
        };
        if (reduceMotion) { swap(); } else { setTimeout(swap, 120); }
        gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
          t.setAttribute('aria-current', t === thumb ? 'true' : 'false');
        });
      });
    });
  });

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    var input = btn.closest('.qty').querySelector('input');
    var value = parseInt(input.value, 10) || 1;
    var next = value + parseInt(btn.dataset.qtyChange, 10);
    var min = parseInt(input.min, 10) || (input.dataset.allowZero ? 0 : 1);
    if (next < min) next = min;
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Variant picker ---------- */
  document.querySelectorAll('[data-product-form]').forEach(function (wrapper) {
    var jsonEl = wrapper.querySelector('[data-product-json]');
    if (!jsonEl) return;
    var product;
    try { product = JSON.parse(jsonEl.textContent); } catch (err) { return; }

    var idInput = wrapper.querySelector('[name="id"]');
    var priceEl = wrapper.querySelector('[data-price]');
    var addBtn = wrapper.querySelector('[data-add-to-cart]');
    var addBtnText = wrapper.querySelector('[data-add-to-cart-text]');
    var moneyFormat = wrapper.dataset.moneyFormat || '£{{amount}}';

    function formatMoney(cents) {
      var amount = (cents / 100).toFixed(2).replace(/\.00$/, '');
      return moneyFormat.replace(/\{\{\s*amount[^}]*\}\}/, amount);
    }

    function selectedOptions() {
      var opts = [];
      wrapper.querySelectorAll('[data-option-index]').forEach(function (group) {
        var select = group.querySelector('select');
        var checked = group.querySelector('input:checked');
        var field = select || checked;
        if (field) opts[parseInt(group.dataset.optionIndex, 10)] = field.value;
      });
      return opts;
    }

    function update() {
      var opts = selectedOptions();
      var variant = product.variants.find(function (v) {
        return v.options.every(function (val, i) { return val === opts[i]; });
      });

      wrapper.querySelectorAll('[data-option-value-label]').forEach(function (label) {
        var group = label.closest('[data-option-index]');
        var select = group && group.querySelector('select');
        var checked = group && group.querySelector('input:checked');
        var field = select || checked;
        if (field) label.textContent = field.value;
      });

      if (!variant) {
        if (addBtn) { addBtn.disabled = true; }
        if (addBtnText) { addBtnText.textContent = 'Unavailable'; }
        return;
      }

      if (idInput) idInput.value = variant.id;

      if (priceEl) {
        var html = '';
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          html = '<span class="price__sale">' + formatMoney(variant.price) + '</span>' +
                 '<s class="price__compare">' + formatMoney(variant.compare_at_price) + '</s>';
        } else {
          html = formatMoney(variant.price);
        }
        priceEl.innerHTML = html;
      }

      if (addBtn && addBtnText) {
        if (variant.available) {
          addBtn.disabled = false;
          addBtnText.textContent = addBtn.dataset.labelAdd || 'Add to cart';
        } else {
          addBtn.disabled = true;
          addBtnText.textContent = 'Sold out';
        }
      }

      var waBtn = wrapper.querySelector('[data-whatsapp-link]');
      if (waBtn) {
        var base = waBtn.dataset.whatsappBase;
        var msg = 'Hi! I would like to enquire about: ' + product.title +
                  ' (' + variant.title + ') - ' + window.location.href;
        waBtn.href = base + encodeURIComponent(msg);
      }

      if (history.replaceState && variant.id) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url.toString());
      }
    }

    wrapper.querySelectorAll('[data-option-index] input, [data-option-index] select').forEach(function (input) {
      input.addEventListener('change', update);
    });
    update();
  });

  /* ---------- AJAX add to cart ---------- */
  var toast = document.getElementById('CartToast');
  var toastTimer;

  function showToast(message) {
    if (!toast) return;
    toast.querySelector('.toast__text').textContent = message;
    toast.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.hidden = true; }, 4000);
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.dataset.count = cart.item_count;
        });
      });
  }

  document.querySelectorAll('form[data-ajax-cart]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[data-add-to-cart]');
      var btnText = form.querySelector('[data-add-to-cart-text]');
      var original = btnText ? btnText.textContent : '';
      if (btn) { btn.disabled = true; }
      if (btnText) { btnText.textContent = 'Adding…'; }

      var properties = {};
      form.querySelectorAll('[name^="properties["]').forEach(function (field) {
        if ((field.type === 'checkbox' || field.type === 'radio') && !field.checked) return;
        var match = field.name.match(/^properties\[(.+)\]$/);
        var value = (field.value || '').trim();
        if (match && value) properties[match[1]] = value;
      });

      var payload = {
        id: parseInt(form.querySelector('[name="id"]').value, 10),
        quantity: parseInt((form.querySelector('[name="quantity"]') || { value: 1 }).value, 10)
      };
      if (Object.keys(properties).length) payload.properties = properties;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || 'Could not add to cart'); });
          return r.json();
        })
        .then(function () {
          if (window.hsfCartAdded) {
            window.hsfCartAdded();
          } else {
            showToast('Added to your cart');
          }
          updateCartCount();
        })
        .catch(function (err) {
          showToast(err.message);
        })
        .finally(function () {
          if (btn) { btn.disabled = false; }
          if (btnText) { btnText.textContent = original; }
        });
    });
  });

  /* ---------- Cart page: auto-submit quantity changes ---------- */
  document.querySelectorAll('[data-cart-line-qty]').forEach(function (input) {
    input.addEventListener('change', function () {
      var form = input.closest('form');
      if (form) form.submit();
    });
  });

  /* ---------- Collection filters ---------- */
  var filterToggle = document.querySelector('[data-filter-toggle]');
  var filters = document.getElementById('CollectionFilters');
  var filtersScrim = document.querySelector('.filters__scrim');

  /* The mobile drawer is position:fixed, but the page-transition on
     .main-content creates a stacking context that would trap it below the
     header. So while open we portal the drawer + scrim up to <body>, then
     return them for the desktop sticky sidebar. */
  var filtersHome = null, filtersAnchor = null;
  function portalOut() {
    if (!filters || filtersHome) return;
    filtersHome = filters.parentNode;
    filtersAnchor = document.createComment('filters-home');
    filtersHome.insertBefore(filtersAnchor, filters);
    document.body.appendChild(filters);
    if (filtersScrim) document.body.appendChild(filtersScrim);
  }
  function portalBack() {
    if (!filters || !filtersHome) return;
    if (filtersScrim) filtersHome.insertBefore(filtersScrim, filtersAnchor);
    filtersHome.insertBefore(filters, filtersAnchor);
    if (filtersAnchor && filtersAnchor.parentNode) filtersAnchor.parentNode.removeChild(filtersAnchor);
    filtersHome = null; filtersAnchor = null;
  }

  function openFilters() {
    if (!filters) return;
    portalOut();
    /* next frame so the slide-in transition runs from the off-screen state */
    requestAnimationFrame(function () {
      filters.classList.add('is-open');
      document.body.classList.add('filters-open');
      if (filterToggle) filterToggle.setAttribute('aria-expanded', 'true');
    });
  }
  function closeFilters() {
    if (!filters) return;
    filters.classList.remove('is-open');
    document.body.classList.remove('filters-open');
    if (filterToggle) filterToggle.setAttribute('aria-expanded', 'false');
    setTimeout(function () {
      if (!filters.classList.contains('is-open')) portalBack();
    }, 340);
  }

  if (filterToggle && filters) {
    filterToggle.addEventListener('click', function () {
      if (filters.classList.contains('is-open')) { closeFilters(); } else { openFilters(); }
    });
    document.querySelectorAll('[data-filter-close]').forEach(function (el) {
      el.addEventListener('click', closeFilters);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && filters.classList.contains('is-open')) closeFilters();
    });
    /* If the viewport grows to desktop while open, restore the in-grid sidebar */
    var filtersDesktopMq = window.matchMedia('(min-width: 990px)');
    (filtersDesktopMq.addEventListener
      ? filtersDesktopMq.addEventListener.bind(filtersDesktopMq, 'change')
      : filtersDesktopMq.addListener.bind(filtersDesktopMq))(function (e) {
        if (e.matches) {
          filters.classList.remove('is-open');
          document.body.classList.remove('filters-open');
          portalBack();
        }
      });
  }

  /* Desktop applies instantly on change; mobile defers to the Apply button */
  var filtersDesktop = window.matchMedia('(min-width: 990px)');
  document.querySelectorAll('[data-filter-form] input[type="checkbox"]').forEach(function (input) {
    input.addEventListener('change', function () {
      if (filtersDesktop.matches) input.closest('form').submit();
    });
  });
  var sortSelect = document.querySelector('[data-sort-by]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }
})();

/* ==========================================================================
   Premium feature layer
   ========================================================================== */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = window.Shopify && window.Shopify.designMode;

  function money(cents, format) {
    var amount = (cents / 100).toFixed(2).replace(/\.00$/, '');
    return (format || '£{{amount}}').replace(/\{\{\s*amount[^}]*\}\}/, amount);
  }

  function lockScroll(cls) { document.body.classList.add(cls); }
  function unlockScroll(cls) { document.body.classList.remove(cls); }

  /* ---------- Cart drawer ---------- */
  var drawer = document.getElementById('CartDrawer');

  function esc(value) {
    return String(value || '').replace(/[&<>"']/g, function (ch) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[ch];
    });
  }

  function renderCart(cart, openAfter) {
    if (!drawer) return;
    var fmt = drawer.dataset.moneyFormat;
    var threshold = parseInt(drawer.dataset.freeShipping || '0', 10) * 100;
    var linesEl = drawer.querySelector('[data-drawer-lines]');
    var footEl = drawer.querySelector('[data-drawer-foot]');
    var shipEl = drawer.querySelector('[data-drawer-shipbar]');

    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.dataset.count = cart.item_count;
    });

    if (cart.item_count === 0) {
      linesEl.innerHTML =
        '<div class="cart-drawer__empty">' +
        (document.getElementById('EmptyCartArt') ? '<div class="brand-illustration">' + document.getElementById('EmptyCartArt').innerHTML + '</div>' : '') +
        '<h3>Your cart is empty</h3>' +
        '<p>Beautiful rooms start with one piece.</p>' +
        '<a class="btn btn--gold" href="/collections/all">Browse furniture</a></div>';
      footEl.hidden = true;
      if (shipEl) shipEl.hidden = true;
    } else {
      linesEl.innerHTML = cart.items.map(function (item, i) {
        var props = Object.keys(item.properties || {}).filter(function (key) {
          return key.charAt(0) !== '_' && item.properties[key];
        }).map(function (key) {
          return '<div><span>' + esc(key) + ':</span> ' + esc(item.properties[key]) + '</div>';
        }).join('');
        return '<div class="cart-drawer__line" data-line="' + (i + 1) + '">' +
          '<img src="' + (item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/, '_180x$1$2') : '') + '" alt="" loading="lazy">' +
          '<div><div class="cart-drawer__line-title">' + item.product_title + '</div>' +
          (item.variant_title ? '<div class="cart-drawer__line-variant">' + item.variant_title + '</div>' : '') +
          (props ? '<div class="cart-drawer__line-properties">' + props + '</div>' : '') +
          '<div class="cart-drawer__line-price">' + money(item.final_line_price, fmt) + '</div>' +
          '<span class="cart-drawer__line-remove" data-drawer-remove role="button" tabindex="0">Remove</span></div>' +
          '<div class="qty">' +
          '<button type="button" data-drawer-qty-change="-1" aria-label="Decrease quantity"><svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><path d="M5 12h14"/></svg></button>' +
          '<input type="number" value="' + item.quantity + '" min="0" data-drawer-qty inputmode="numeric" aria-label="Quantity">' +
          '<button type="button" data-drawer-qty-change="1" aria-label="Increase quantity"><svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg></button>' +
          '</div></div>';
      }).join('');
      footEl.hidden = false;
      drawer.querySelector('[data-drawer-total]').textContent = money(cart.total_price, fmt);

      if (shipEl) {
        shipEl.hidden = false;
        if (threshold > 0) {
          var remaining = threshold - cart.total_price;
          if (remaining > 0) {
            shipEl.innerHTML = 'You are <strong>' + money(remaining, fmt) + '</strong> away from the delivery offer' +
              '<div class="shipbar__track"><div class="shipbar__fill" style="width:' + Math.min(100, (cart.total_price / threshold) * 100) + '%"></div></div>';
          } else {
            shipEl.innerHTML = '<strong>Delivery offer unlocked</strong>' +
              '<div class="shipbar__track"><div class="shipbar__fill" style="width:100%"></div></div>';
          }
        } else {
          shipEl.innerHTML = 'Delivery is available across Scotland. Charges are shown at checkout or confirmed before dispatch.';
        }
      }
    }
    if (openAfter) openCartDrawer();
  }

  function refreshCart(openAfter) {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart, openAfter); });
  }

  function openCartDrawer() { if (drawer) lockScroll('cart-open'); }
  function closeCartDrawer() { unlockScroll('cart-open'); }

  window.hsfCartAdded = function () { refreshCart(true); };

  if (drawer) {
    refreshCart(false);
    document.querySelectorAll('[data-cart-open]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        refreshCart(true);
      });
    });
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-drawer-close]')) closeCartDrawer();
      var stepBtn = e.target.closest('[data-drawer-qty-change]');
      var removeBtn = e.target.closest('[data-drawer-remove]');
      var line = e.target.closest('[data-line]');
      if (!line) return;
      if (stepBtn) {
        var input = line.querySelector('[data-drawer-qty]');
        var next = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(stepBtn.dataset.drawerQtyChange, 10));
        changeLine(parseInt(line.dataset.line, 10), next);
      } else if (removeBtn) {
        changeLine(parseInt(line.dataset.line, 10), 0);
      }
    });
    drawer.addEventListener('change', function (e) {
      var input = e.target.closest('[data-drawer-qty]');
      var line = e.target.closest('[data-line]');
      if (input && line) changeLine(parseInt(line.dataset.line, 10), Math.max(0, parseInt(input.value, 10) || 0));
    });
    document.querySelector('.cart-drawer__scrim').addEventListener('click', closeCartDrawer);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCartDrawer(); });
  }

  function changeLine(line, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(function (cart) { renderCart(cart, false); });
  }

  /* ---------- Lightbox ---------- */
  var lightbox = document.getElementById('Lightbox');
  var lbImages = [], lbIndex = 0;

  function openLightbox(images, index) {
    if (!lightbox || !images.length) return;
    lbImages = images; lbIndex = index || 0;
    updateLightbox();
    lightbox.hidden = false;
    lockScroll('modal-open');
  }
  function updateLightbox() {
    var img = lightbox.querySelector('img');
    var wrap = lightbox.querySelector('.lightbox__img-wrap');
    wrap.classList.remove('is-zoomed');
    img.src = lbImages[lbIndex];
    lightbox.querySelector('.lightbox__count').textContent = (lbIndex + 1) + ' / ' + lbImages.length;
    lightbox.querySelectorAll('.lightbox__nav').forEach(function (n) { n.style.display = lbImages.length > 1 ? '' : 'none'; });
  }
  function closeLightbox() { if (lightbox) { lightbox.hidden = true; unlockScroll('modal-open'); } }

  if (lightbox) {
    lightbox.addEventListener('click', function (e) {
      if (e.target.closest('[data-lb-close]') || e.target.classList.contains('lightbox__scrim')) { closeLightbox(); return; }
      if (e.target.closest('[data-lb-prev]')) { lbIndex = (lbIndex - 1 + lbImages.length) % lbImages.length; updateLightbox(); return; }
      if (e.target.closest('[data-lb-next]')) { lbIndex = (lbIndex + 1) % lbImages.length; updateLightbox(); return; }
      var wrap = e.target.closest('.lightbox__img-wrap');
      if (wrap) {
        var img = wrap.querySelector('img');
        var r = img.getBoundingClientRect();
        img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
        wrap.classList.toggle('is-zoomed');
      }
    });
    document.addEventListener('keydown', function (e) {
      if (lightbox.hidden) return;
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowLeft' && lbImages.length > 1) { lbIndex = (lbIndex - 1 + lbImages.length) % lbImages.length; updateLightbox(); }
      if (e.key === 'ArrowRight' && lbImages.length > 1) { lbIndex = (lbIndex + 1) % lbImages.length; updateLightbox(); }
    });
    document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
      var main = gallery.querySelector('[data-gallery-main]');
      if (!main) return;
      main.addEventListener('click', function () {
        var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
        var images = thumbs.length
          ? Array.prototype.map.call(thumbs, function (t) { return t.dataset.src; })
          : [main.querySelector('img') && main.querySelector('img').src].filter(Boolean);
        var current = main.querySelector('img') ? main.querySelector('img').src : images[0];
        openLightbox(images, Math.max(0, images.indexOf(current)));
      });
    });
  }

  /* ---------- Quick view ---------- */
  var qvModal = document.getElementById('QuickView');

  function closeQuickView() { if (qvModal) { qvModal.hidden = true; unlockScroll('modal-open'); } }

  if (qvModal) {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-quick-view]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      fetch('/products/' + btn.dataset.quickView + '.js')
        .then(function (r) { return r.json(); })
        .then(function (product) { openQuickView(product); });
    });
    qvModal.addEventListener('click', function (e) {
      if (e.target.closest('[data-modal-close]') || e.target.classList.contains('modal__scrim')) closeQuickView();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeQuickView(); });
  }

  function openQuickView(product) {
    var fmt = qvModal.dataset.moneyFormat;
    var body = qvModal.querySelector('[data-qv-body]');
    var hasOptions = !(product.options.length === 1 && product.options[0].values.length === 1 && product.options[0].values[0] === 'Default Title');
    var optionsHtml = '';
    if (hasOptions) {
      optionsHtml = product.options.map(function (opt, oi) {
        return '<fieldset class="variant-field" data-qv-option-index="' + oi + '">' +
          '<legend>' + opt.name + '</legend><div class="variant-pills">' +
          opt.values.map(function (v, vi) {
            return '<label class="variant-pill"><input type="radio" name="qv-option-' + oi + '" value="' + v.replace(/"/g, '&quot;') + '"' + (vi === 0 ? ' checked' : '') + '><span>' + v + '</span></label>';
          }).join('') + '</div></fieldset>';
      }).join('');
    }
    body.innerHTML =
      '<div class="qv">' +
      '<div class="qv__media"><img src="' + (product.featured_image || '') + '" alt=""></div>' +
      '<div>' +
      '<span class="product-info__vendor">' + (product.vendor || '') + '</span>' +
      '<h3 class="qv__title">' + product.title + '</h3>' +
      '<p class="qv__price" data-qv-price>' + money(product.price, fmt) + '</p>' +
      optionsHtml +
      '<button type="button" class="btn btn--gold btn--full" data-qv-add' + (product.available ? '' : ' disabled') + '>' + (product.available ? 'Add to cart' : 'Sold out') + '</button>' +
      '<a class="qv__link" href="' + product.url + '">View full details</a>' +
      '</div></div>';

    function selectedVariant() {
      var chosen = [];
      body.querySelectorAll('[data-qv-option-index]').forEach(function (group) {
        var input = group.querySelector('input:checked');
        chosen[parseInt(group.dataset.qvOptionIndex, 10)] = input && input.value;
      });
      if (!chosen.length) return product.variants[0];
      return product.variants.find(function (v) {
        return v.options.every(function (val, i) { return val === chosen[i]; });
      });
    }

    body.addEventListener('change', function () {
      var v = selectedVariant();
      var priceEl = body.querySelector('[data-qv-price]');
      var addBtn = body.querySelector('[data-qv-add]');
      if (v) {
        priceEl.textContent = money(v.price, fmt);
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? 'Add to cart' : 'Sold out';
        if (v.featured_image && v.featured_image.src) body.querySelector('.qv__media img').src = v.featured_image.src;
      } else {
        addBtn.disabled = true;
        addBtn.textContent = 'Unavailable';
      }
    });

    body.querySelector('[data-qv-add]').addEventListener('click', function () {
      var v = selectedVariant();
      if (!v) return;
      var btn = this;
      btn.disabled = true; btn.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: v.id, quantity: 1 })
      }).then(function (r) { return r.json(); }).then(function () {
        closeQuickView();
        if (window.hsfCartAdded) window.hsfCartAdded();
      }).finally(function () { btn.disabled = false; btn.textContent = 'Add to cart'; });
    });

    qvModal.hidden = false;
    lockScroll('modal-open');
  }

  /* ---------- Sticky add to cart ---------- */
  var stickyBar = document.querySelector('[data-sticky-atc]');
  var buyBox = document.querySelector('.buy-buttons');
  if (stickyBar && buyBox && 'IntersectionObserver' in window) {
    var stickyObserver = new IntersectionObserver(function (entries) {
      var visible = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
      stickyBar.classList.toggle('is-visible', visible);
      document.body.classList.toggle('atc-stuck', visible);
    }, { threshold: 0 });
    stickyObserver.observe(buyBox);
    stickyBar.querySelector('[data-sticky-add]').addEventListener('click', function () {
      var form = document.querySelector('[data-product-form] form[data-ajax-cart]');
      if (form) { form.requestSubmit ? form.requestSubmit() : form.submit(); }
    });
  }

  /* ---------- Predictive search ---------- */
  var searchOverlay = document.getElementById('SearchOverlay');
  if (searchOverlay) {
    var searchScrim = document.querySelector('.search-overlay__scrim');
    var searchInput = searchOverlay.querySelector('.search-overlay__input');
    var resultsEl = searchOverlay.querySelector('.search-results');
    var searchTimer;

    function openSearch() {
      searchOverlay.classList.add('is-open');
      searchScrim.classList.add('is-open');
      setTimeout(function () { searchInput.focus(); }, 80);
    }
    function closeSearch() {
      searchOverlay.classList.remove('is-open');
      searchScrim.classList.remove('is-open');
    }
    document.querySelectorAll('[data-search-open]').forEach(function (el) {
      el.addEventListener('click', function (e) { e.preventDefault(); openSearch(); });
    });
    searchOverlay.querySelector('[data-search-close]').addEventListener('click', closeSearch);
    searchScrim.addEventListener('click', closeSearch);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSearch(); });

    searchInput.addEventListener('input', function () {
      clearTimeout(searchTimer);
      var q = searchInput.value.trim();
      if (q.length < 2) { resultsEl.innerHTML = ''; return; }
      searchTimer = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var products = data.resources.results.products || [];
            if (!products.length) {
              resultsEl.innerHTML = '<p class="search-results__empty">No pieces found for "' + q.replace(/</g, '&lt;') + '"</p>';
              return;
            }
            resultsEl.innerHTML = products.map(function (p) {
              return '<a class="search-result" href="' + p.url + '">' +
                '<img src="' + (p.featured_image && p.featured_image.url ? p.featured_image.url : '') + '" alt="" loading="lazy">' +
                '<span><span class="search-result__title">' + p.title + '</span><br>' +
                '<span class="search-result__price">' + (p.price ? '£' + p.price : '') + '</span></span></a>';
            }).join('') +
            '<a class="search-results__all" href="/search?q=' + encodeURIComponent(q) + '">View all results</a>';
          });
      }, 250);
    });
  }

  /* ---------- Recently viewed ---------- */
  var RV_KEY = 'hsf-recently-viewed';
  var rvSection = document.querySelector('[data-recently-viewed]');
  var currentHandle = document.querySelector('[data-product-handle]');
  try {
    var rvList = JSON.parse(localStorage.getItem(RV_KEY) || '[]');
    if (rvSection) {
      var fmt2 = rvSection.dataset.moneyFormat;
      var currentFinish = (rvSection.dataset.currentFinish || '').toLowerCase();
      var show = rvList.filter(function (h) { return !currentHandle || h !== currentHandle.dataset.productHandle; }).slice(0, 4);
      if (show.length) {
        Promise.all(show.map(function (h) {
          return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
        })).then(function (products) {
          products = products.filter(Boolean).filter(function (p) {
            if (!currentFinish) return true;
            var title = (p.title || '').toLowerCase();
            var tags = (p.tags || []).map(function (tag) { return String(tag).toLowerCase(); });
            return title.indexOf(currentFinish) !== -1 || tags.indexOf(currentFinish) !== -1;
          });
          if (!products.length) return;
          rvSection.querySelector('[data-rv-grid]').innerHTML = products.map(function (p) {
            return '<a class="product-card" href="' + p.url + '">' +
              '<div class="product-card__media"><img src="' + (p.featured_image || '') + '" alt="" loading="lazy"></div>' +
              '<div class="product-card__info"><span class="product-card__title">' + p.title + '</span>' +
              '<span class="product-card__price">' + money(p.price, fmt2) + '</span></div></a>';
          }).join('');
          rvSection.hidden = false;
        });
      }
    }
    if (currentHandle) {
      var h = currentHandle.dataset.productHandle;
      rvList = [h].concat(rvList.filter(function (x) { return x !== h; })).slice(0, 8);
      localStorage.setItem(RV_KEY, JSON.stringify(rvList));
    }
  } catch (err) { /* localStorage unavailable */ }

  /* ---------- Hotspots (touch toggle) ---------- */
  document.querySelectorAll('.hotspot__dot').forEach(function (dot) {
    dot.addEventListener('click', function (e) {
      var spot = dot.closest('.hotspot');
      var wasOpen = spot.classList.contains('is-open');
      document.querySelectorAll('.hotspot.is-open').forEach(function (s) { s.classList.remove('is-open'); });
      if (!wasOpen) spot.classList.add('is-open');
      e.stopPropagation();
    });
  });
  document.addEventListener('click', function () {
    document.querySelectorAll('.hotspot.is-open').forEach(function (s) { s.classList.remove('is-open'); });
  });

  /* ---------- Before / after slider ---------- */
  document.querySelectorAll('.ba').forEach(function (ba) {
    function setPos(clientX) {
      var r = ba.getBoundingClientRect();
      var pct = Math.max(4, Math.min(96, ((clientX - r.left) / r.width) * 100));
      ba.style.setProperty('--ba', pct + '%');
    }
    ba.addEventListener('pointerdown', function (e) {
      setPos(e.clientX);
      ba.setPointerCapture(e.pointerId);
      ba.addEventListener('pointermove', onMove);
    });
    ba.addEventListener('pointerup', function () { ba.removeEventListener('pointermove', onMove); });
    function onMove(e) { setPos(e.clientX); }
  });

  /* ---------- Newsletter popup ---------- */
  var popup = document.getElementById('NewsletterPopup');
  if (popup && !designMode) {
    var POPUP_KEY = 'hsf-popup-dismissed';
    var dismissedAt = 0;
    try { dismissedAt = parseInt(localStorage.getItem(POPUP_KEY) || '0', 10); } catch (e) {}
    var posted = window.location.search.indexOf('customer_posted=true') !== -1;
    var daysSince = (Date.now() - dismissedAt) / 86400000;

    function dismissPopup() {
      popup.hidden = true;
      unlockScroll('modal-open');
      try { localStorage.setItem(POPUP_KEY, String(Date.now())); } catch (e) {}
    }

    function tryShowPopup() {
      /* Wait politely if the customer is mid-cart or mid-modal */
      if (document.body.classList.contains('cart-open') ||
          document.body.classList.contains('modal-open') ||
          document.body.classList.contains('drawer-open')) {
        setTimeout(tryShowPopup, 20000);
        return;
      }
      popup.hidden = false;
    }

    if (posted) {
      try { localStorage.setItem(POPUP_KEY, String(Date.now())); } catch (e) {}
    } else if (!dismissedAt || daysSince > 30) {
      setTimeout(tryShowPopup, parseInt(popup.dataset.delay || '15', 10) * 1000);
    }
    popup.addEventListener('click', function (e) {
      if (e.target.closest('[data-popup-close]') || e.target.classList.contains('popup__scrim')) dismissPopup();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !popup.hidden) dismissPopup(); });
  }

  /* ---------- Read more clamp ---------- */
  document.querySelectorAll('[data-clamp]').forEach(function (clamp) {
    var toggle = clamp.parentElement.querySelector('[data-clamp-toggle]');
    if (!toggle) return;
    if (clamp.scrollHeight > clamp.clientHeight + 4) {
      toggle.hidden = false;
      toggle.addEventListener('click', function () {
        var open = clamp.classList.toggle('is-open');
        toggle.querySelector('[data-clamp-more]').hidden = open;
        toggle.querySelector('[data-clamp-less]').hidden = !open;
      });
    }
  });

  /* ---------- Immediate account redirects ---------- */
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
    var link = e.target.closest('a[data-immediate-link]');
    if (!link || link.target || link.hasAttribute('download')) return;
    e.preventDefault();
    window.location.assign(link.href);
  }, true);

  /* ---------- Page transitions ---------- */
  if (!reduceMotion && !designMode) {
    document.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
      var link = e.target.closest('a[href]');
      if (!link || link.target || link.hasAttribute('download') || link.hasAttribute('data-no-transition')) return;
      if (link.closest('.modal, .lightbox, .popup, [data-gallery]')) return;
      var url = new URL(link.href, window.location.href);
      if (url.origin !== window.location.origin) return;
      if (url.pathname === window.location.pathname && url.hash) return;
      e.preventDefault();
      document.documentElement.classList.add('page-leaving');
      setTimeout(function () { window.location.href = link.href; }, 160);
    });
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) document.documentElement.classList.remove('page-leaving');
    });
  }
})();
